(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}

		sliders.forEach((slider) => {
			if (slider.swiper) {
				slider.swiper.destroy(true, true);
			}

			const cardInner = slider.closest(".card__inner");
			const paginationEl = cardInner
				? cardInner.querySelector(".product-pagination .swiper-pagination")
				: null;

			new Swiper(slider, {
				pagination: paginationEl
					? {
						el: paginationEl,
						type: "bullets",
						clickable: false,
						bulletClass: "product-pagination__dash",
						bulletActiveClass: "product-pagination__dash--active",
					}
					: false,
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					},
				},
				on: {
					slideChange: function (swiper) {
						if (swiper.pagination && swiper.pagination.el) {
							swiper.pagination.render();
							swiper.pagination.update();
						}
					},
				},
			});
		});
	};

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
